import { createContext, useContext, useState, useEffect } from 'react';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import cognitoConfig from '../components/loginAWS/cognitoConfig.json';

const AuthContext = createContext();
const userPool = new CognitoUserPool({
  UserPoolId: cognitoConfig.UserPoolId,
  ClientId: cognitoConfig.ClientId
});

export const AuthProvider = ({ children }) => {
  const [authUser, setAuthUser] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem('authUser');
    if (stored) {
      const parsed = JSON.parse(stored);
      const cognitoUser = userPool.getCurrentUser();

      if (cognitoUser) {
        cognitoUser.getSession((err, session) => {
          // Handle errors gracefully - don't spam console with 400 errors
          if (err) {
            // Only log non-400 errors (400 usually means expired/invalid token, which is expected)
            if (err.code !== 'NotAuthorizedException' && err.statusCode !== 400) {
              console.warn('[AuthContext] Session error:', err);
            }
            localStorage.removeItem('authUser');
            setAuthUser(null);
            return;
          }
          
          if (!session || !session.isValid()) {
            localStorage.removeItem('authUser');
            setAuthUser(null);
          } else {
            setAuthUser(session);
          }
        });
      } else {
        setAuthUser(null);
      }
    }
  }, []);

  return (
    <AuthContext.Provider value={{ authUser, setAuthUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
